// extracted by mini-css-extract-plugin
export default {"list":"ApplicationsList_list__10cJB","empty":"ApplicationsList_empty__R2pdQ"};